import React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import type { FinixPaymentMethod } from './types';

export interface FinixPaymentMethodConfig {
  description: string;
  icon: React.ElementType;
  id: FinixPaymentMethod;
  label: string;
  mark: string;
}

interface FinixPaymentMethodOptionProps {
  method: FinixPaymentMethodConfig;
  onSelect: (method: FinixPaymentMethod) => void;
  selected: boolean;
}

const FinixPaymentMethodOption: React.FC<FinixPaymentMethodOptionProps> = ({
  method,
  onSelect,
  selected,
}) => {
  const MethodIcon = method.icon;

  return (
    <Button
      color="inherit"
      onClick={() => onSelect(method.id)}
      sx={{
        bgcolor: selected ? 'var(--cx-brand-button-selected-bg)' : 'var(--cx-brand-button-bg)',
        border: '1px solid',
        borderColor: selected
          ? 'var(--cx-brand-button-selected-border)'
          : 'var(--cx-brand-button-border)',
        color: selected ? 'var(--cx-brand-button-selected-text)' : 'var(--cx-brand-button-text)',
        justifyContent: 'flex-start',
        minHeight: 62,
        p: 1.15,
      }}
      type="button"
      variant="outlined"
    >
      <Box
        sx={{
          alignItems: 'center',
          bgcolor: 'var(--cx-brand-button-hover-bg)',
          borderRadius: 1,
          display: 'flex',
          flexShrink: 0,
          fontWeight: 900,
          height: 38,
          justifyContent: 'center',
          mr: 1.25,
          width: 54,
        }}
      >
        {method.mark}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
        <Typography variant="subtitle2">{method.label}</Typography>
        <Typography variant="caption" sx={{ color: 'var(--cx-brand-text-muted)' }}>
          {method.description}
        </Typography>
      </Box>
      <MethodIcon sx={{ color: 'var(--cx-brand-text-muted)' }} />
    </Button>
  );
};

export default FinixPaymentMethodOption;
